import React, { useRef, useState } from 'react';
import { FullBackground } from '../../../components/FullBackground';
import { useHistory } from 'react-router';

type Props = {
  className?: string;
};

export const PDFTLDR: React.FC<Props> = props => {
  const testimonialRef = useRef();
  const history = useHistory();
  const [email, setEmail] = useState('');
  // useScrollPosition(({ currPos }) => {
  //   console.log(currPos)
  //   if (currPos.y < 500){
  //     const already_shown = localStorage.getItem('pdf_popup_shown') ?? 'false'
  //     const email_already_given = localStorage.getItem('email_identified') ?? 'false'
  //     if (email_already_given === 'false' && already_shown === 'false') (
  //         setShowEmail(true)
  //     )
  //   }
  // }, [], testimonialRef)
  return (
    <>
      <FullBackground color={'bg-gray-900'} isSlanted={false}>
        <div
          className={`${props.className}`}
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          ref={testimonialRef}
        >
          <div className="relative max-w-xl max-w-7xl">
            <div className="max-w-3xl mx-auto text-center ">
              <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">
                TL;DR
              </h2>
              <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
                In a nutshell, why us?
              </p>
            </div>
            <div className="relative mt-8 md:mt-12 md:items-start">
              <div
                className={
                  ' mx-auto flex-col mt-10 md:mt-0 px-0 2xl:w-2/4 md:w-4/5 lg:w-3/4 xl:w-2/3'
                }
              >
                <div className=" text-base mx-auto  sm:text-lg text-left md:text-xl text-white mt-4">
                  We built TableTab to improve your guest’s experience and
                  increase your restaurant’s efficiency and safety. PDF’s hinder
                  great guest experiences and leave uncaptured incremental spend
                  sitting at the table. Switch today and see what you’ve been
                  missing.
                </div>
              </div>
            </div>

            {/*<div*/}
            {/*  className="mt-12 sm:mt-12 md:mt-14 2xl:mt-16 xl:mt-16 lg:mt-14 w-2/10  text-center"*/}
            {/*  id={'pdf_banner_cta'}*/}
            {/*>*/}
            {/*  <a*/}
            {/*    href="/contact"*/}
            {/*    className="items-center justify-center px-10 py-3 border border-transparent text-lg font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 hover:text-white"*/}
            {/*  >*/}
            {/*    Get an upgrade*/}
            {/*  </a>*/}
            {/*</div>*/}
            <div className="mx-auto mt-6 md:mt-10">
              <form
                className="mt-5 sm:flex sm:items-center 2xl:w-1/2 xl:w-3/5 lg:w-3/4 md:w-4/5 sm:w-full justify-center mx-auto "
                id={'pdf_tldr_form'}
                onSubmit={e => {
                  e.preventDefault();
                  // @ts-ignore
                  window.analytics.identify({
                    email: email,
                  });
                  window.open(
                    'https://portal.tabletab.io/signup?ref=pdf_tldr_form',
                  );
                }}
              >
                <div className="max-w-xs w-full">
                  <label htmlFor="email" className="sr-only">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    required
                    onChange={e => {
                      setEmail(e.target.value);
                    }}
                    className="shadow-sm focus:ring-primary-600 focus:border-primary-600 block w-full text-base border-gray-300 rounded-full"
                    placeholder="Enter your email"
                  />
                </div>
                <button
                  type="submit"
                  className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base shadow-sm font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 sm:mt-0 sm:ml-3 sm:w-2/3 lg:w-1/2  2xl:w-1/2 "
                >
                  Get your free digital menu
                </button>
              </form>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};
